import styled from '@emotion/styled';

export const Svg = styled.svg`
  height: 100%;
`;
